<ng-container *ngIf="previewAddLicencesResponse$ | async as preview; else loading">
  <div class="row">
    <div class="col-xl-8">
      <div class="card mt-4 ms-4">
        <div class="card-body pt-4">
          <div class="d-flex justify-content-between border-bottom pb-2">
            <h2>Add Licences</h2>
          </div>
          <div class="row pt-5">
            <div class="col-lg-12">
              <!--<h4 class="col-lg-12 text-lg-center py-4">Plan details</h4>-->
              <div class="row">
                <p class="col-lg-6 text-lg-end">Current Licences:</p>
                <p class="col-lg-6 fw-bold">{{ preview.summary.currentLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Added Licences:</p>
                <p class="col-lg-6 fw-bold">{{ preview.summary.addedLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">New Total Licences:</p>
                <p class="col-lg-6 fw-bold">{{ preview.summary.newTotalLicences }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Prorated Cost:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    preview.summary.proratedCost
                      | currency: preview.summary.currency : 'symbol' : '1.2-2'
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Available Credit:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    preview.summary.availableCredit
                      | currency: preview.summary.currency : 'symbol' : '1.2-2'
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Credit Applied:</p>
                <p class="col-lg-6 fw-bold">{{ preview.summary.creditApplied }}</p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Amount Due:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    preview.summary.amountDueToday
                      | currency: preview.summary.currency : 'symbol' : '1.2-2'
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Recurring Amount:</p>
                <p class="col-lg-6 fw-bold">
                  {{
                    preview.nextBilling.newRecurringAmount
                      | currency: preview.summary.currency : 'symbol' : '1.2-2'
                  }}
                </p>
              </div>
              <div class="row">
                <p class="col-lg-6 text-lg-end">Next Billing Date:</p>
                <p class="col-lg-6 fw-bold">
                  {{ preview.nextBilling.nextBillingDate | date: 'mediumDate' }}
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="col-xl-4 theiaStickySidebar">
      <div class="card mt-4 me-4">
        <div class="card-body">
          <div class="d-flex justify-content-between border-bottom pb-2 pt-4">
            <h2>Billing Summary</h2>
          </div>
          <div class="total-row pt-4">
            <div class="amount-due">
              <span class="label">Amount Payable</span>
              <span class="value">
                {{
                  preview.summary.amountDueToday
                    | currency: preview.summary.currency : 'symbol' : '1.2-2'
                }}
              </span>
            </div>
          </div>

          <div class="d-grid mt-4">
            <button (click)="confirmAddLicences()" class="btn btn-primary" type="button">
              Confirm
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>

<ng-template #loading>
  <div class="d-flex justify-content-center align-items-center p-5">
    <!--<p>Loading plan summary...</p>-->
  </div>
</ng-template>
